import request from './request';

export type SalesInvoiceItem = {
  id: number;
  name: string;
  price: number;
  quantity: number;
};

export type SalesInvoice = {
  id: string;
  tableName: string;
  paidAt: string;
  total: number;
  items: SalesInvoiceItem[];
};

type SalesHistoryResponse = {
  success: boolean;
  message?: string;
  doanhThu: number;
  soHoaDon: number;
  xuatKhos: Array<{
  id: number;
  key_value: string;
  ngay_xuat_kho: string;
  ghi_chu: string | null;
  tong_so_tien_thanh_toan: number;
  chi_tiet_xuat_khos: Array<{
    id: number;
    hang_hoa_id: number;
    so_luong: number;
    gia_ban: number;
    hang_hoa?: { ten: string } | null;
  }>;
  }>;
};

const salesInvoicesService = {
  getByDateRange: async (
    startDate?: string,
    endDate?: string
  ): Promise<{ invoices: SalesInvoice[]; revenue: number; count: number }> => {
  const response = await request.get<SalesHistoryResponse>('user-sale-lich-su-ban-hang', {
    params: startDate && endDate ? { tu_ngay: startDate, den_ngay: endDate } : {},
  });
  const result = response.data;

  if (!result.success) {
    throw new Error(result.message || 'Không thể tải lịch sử bán hàng');
  }

  return {
    revenue: Number(result.doanhThu) || 0,
    count: result.soHoaDon,
    invoices: result.xuatKhos.map((xuatKho) => ({
      id: xuatKho.key_value,
      tableName: xuatKho.ghi_chu?.replace(/^Thanh toán\s*/, '') || 'Không rõ bàn',
      paidAt: xuatKho.ngay_xuat_kho,
      total: Number(xuatKho.tong_so_tien_thanh_toan) || 0,
      items: xuatKho.chi_tiet_xuat_khos.map((item) => ({
        id: item.hang_hoa_id,
        name: item.hang_hoa?.ten || `Sản phẩm #${item.hang_hoa_id}`,
        price: Number(item.gia_ban) || 0,
        quantity: Number(item.so_luong) || 0,
      })),
    })),
  };
  },
};

export default salesInvoicesService;